// The Night Book. Seven original pages, each with one short code.

const TITLE = "The Night Book";
const DEK = "Seven pages. Each page hides a short code.";
const BOOK_CODE = "51a4a1c0";

const introParagraphs = [
  "This book was left in the watch-room desk. Each page has one code. The codes are short. The last page uses the pages before it.",
  "Every page can be solved from what is printed. No page prints its code.",
];

const PAGES = [
  {
    page: 1,
    title: "The shutter note",
    lines: [
      "Set the west mark.",
      "Hold the lamp low.",
      "Open no gate.",
      "Return by the path.",
      "Every skiff is tied.",
    ],
    ask: "The code is the first letter of each line, in order.",
    answer: "SHORE",
  },
  {
    page: 2,
    title: "The lamp tin",
    lines: [
      "A slip in the lamp tin reads JSPO.",
      "Each letter was moved one step forward in the alphabet.",
    ],
    ask: "Step each letter back once. The code is the word you get.",
    answer: "IRON",
  },
  {
    page: 3,
    title: "The bird list",
    lines: ["One name on the bird list is scrambled: LLUG."],
    ask: "The code is that bird, with the letters put back in order.",
    answer: "GULL",
  },
  {
    page: 4,
    title: "The quay",
    lines: [
      "You are facing the quay.",
      "The quay lies to the south, so you face south.",
      "Turn about, a half turn.",
    ],
    ask: "The code is the direction you face after that turn.",
    answer: "NORTH",
  },
  {
    page: 5,
    title: "The beam",
    lines: ["Someone painted FLASHES along the beam. The word has seven letters."],
    ask: "The code is the third, fourth, and fifth letters.",
    answer: "ASH",
  },
  {
    page: 6,
    title: "The hook",
    lines: ["On the hook by the door: a mallet, a lamp, a broom, and a coil of line."],
    ask: "Take the one that gives light. The code is that object, in the plural.",
    answer: "LAMPS",
  },
  {
    page: 7,
    title: "The last page",
    lines: ["Each earlier page has a code."],
    ask: "Take the first letter of each code, from page 1 through page 6, and write them in that order.",
    answer: "SIGNAL",
  },
];

function foldTight(value) {
  return String(value || "").toLowerCase().replace(/[^a-z0-9]+/g, "");
}

function pageByNumber(page) {
  for (let i = 0; i < PAGES.length; i++) if (PAGES[i].page === page) return PAGES[i];
  return null;
}

function accepts(page, raw) {
  const found = typeof page === "number" ? pageByNumber(page) : page;
  if (!found) return false;
  const got = foldTight(raw);
  return got.length > 0 && got === foldTight(found.answer);
}

function answerRecord() {
  return {
    version: 1,
    code: BOOK_CODE,
    pages: PAGES.map(function (page) {
      return { page: page.page, answer: page.answer };
    }),
  };
}

function assertBook() {
  if (PAGES.length !== 7) throw new Error("The book should have seven pages");
  if (!/^[0-9a-f]{8}$/.test(BOOK_CODE)) throw new Error("The reply code is not eight hex characters");
  const letters = PAGES.slice(0, 6).map(function (page) { return foldTight(page.answer).charAt(0); }).join("");
  if (letters !== foldTight(PAGES[6].answer)) throw new Error("The last code does not match the earlier pages");
  const blob = JSON.stringify({ title: TITLE, pages: PAGES });
  if (/murder|cluedo|murdle|holmes|watson|moriarty|jawbone|journal 29|alice|starling|wordle/i.test(blob)) {
    throw new Error("Reserved wording");
  }
  PAGES.forEach(function (page) {
    if (!page.title || !page.ask || !page.answer) throw new Error("A page is incomplete");
    const printed = (page.lines.join(" ") + " " + page.ask).toLowerCase();
    const word = new RegExp("\\b" + page.answer.toLowerCase() + "\\b");
    if (word.test(printed)) throw new Error("Page " + page.page + " prints its code");
  });
}

function runSelfTest() {
  assertBook();
  if (!accepts(1, " shore ")) throw new Error("Shore should match");
  if (accepts(6, "lamp")) throw new Error("Lamp is not lamps");
  if (!accepts(7, "s i g n a l")) throw new Error("Signal should ignore spaces");
  const summary = "night book pages 7 last " + PAGES[6].answer;
  if (typeof print === "function") print(summary);
  else console.log(summary);
}

if (typeof window === "undefined") runSelfTest();

globalThis.NightBook = {
  TITLE: TITLE,
  DEK: DEK,
  BOOK_CODE: BOOK_CODE,
  introParagraphs: introParagraphs,
  PAGES: PAGES,
  foldTight: foldTight,
  pageByNumber: pageByNumber,
  accepts: accepts,
  answerRecord: answerRecord,
  assertBook: assertBook,
};
